import type { TranslationTree } from '../../types';
import { common } from './common';
import { layout } from './layout';
import { settings } from './settings';
import { profile } from './profile';
import { home } from './home';
import { contact } from './contact';
import { admin } from './admin';
import { adminTools } from './adminTools';
import { analytics } from './analytics';
import { traceability } from './traceability';
import { toolView } from './toolView';
import { mlRul } from './machineLearning';
import { signals } from './signals';
import { auth } from './auth';
import { camera } from './camera';
import { errors } from './errors';
import { labeling } from './labeling';
import { backendConfig } from './backendConfig';
import { modules } from './modules';
import { administration } from './administration';
import { referenceAliases } from './referenceAliases';
import { toolPickers } from './toolPickers';
import { toolRecommender } from './toolRecommender';

export const en: TranslationTree = {
  ...common,
  ...layout,
  ...settings,
  ...profile,
  ...home,
  ...contact,
  ...admin,
  ...adminTools,
  ...analytics,
  ...traceability,
  ...toolView,
  ...mlRul,
  ...signals,
  ...auth,
  ...camera,
  ...errors,
  ...labeling,
  ...backendConfig,
  ...modules,
  ...administration,
  ...referenceAliases,
  ...toolPickers,
  ...toolRecommender,
};
